/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconRubric = (props) => (
  <SVG
    data-cy="rubric-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="14.563"
    height="14.407"
    viewBox="0 0 14.563 14.407"
    {...props}
  >
    <g transform="translate(-573.486 -57.6)">
      <g transform="translate(565.66 57.473)">
        <g transform="translate(7.982 0.127)">
          <path
            d="M188.011.127H182.47a.433.433,0,0,0-.433.433V6.1a.433.433,0,0,0,.433.433h5.541a.433.433,0,0,0,.433-.433V.56A.433.433,0,0,0,188.011.127Z"
            transform="translate(-182.037 -0.127)"
            fill="#bbbfc4"
          />
        </g>
        <path
          d="M1.532,3.452a.2.2,0,0,1-.289,0L.09,2.3a.306.306,0,0,1,0-.433l.144-.144a.306.306,0,0,1,.433,0l.72.72L3.333.5a.306.306,0,0,1,.433,0L3.91.64a.306.306,0,0,1,0,.433Zm0,0"
          transform="translate(9.225 1.5)"
          fill="#fff"
        />
      </g>
      <g transform="translate(573.504 57.473)">
        <g transform="translate(7.982 0.127)">
          <path
            d="M188.011.127H182.47a.433.433,0,0,0-.433.433V6.1a.433.433,0,0,0,.433.433h5.541a.433.433,0,0,0,.433-.433V.56A.433.433,0,0,0,188.011.127Z"
            transform="translate(-182.037 -0.127)"
            fill="#bbbfc4"
          />
        </g>
      </g>
      <g transform="translate(565.504 65.473)">
        <g transform="translate(7.982 0.127)">
          <path
            d="M188.011.127H182.47a.433.433,0,0,0-.433.433V6.1a.433.433,0,0,0,.433.433h5.541a.433.433,0,0,0,.433-.433V.56A.433.433,0,0,0,188.011.127Z"
            transform="translate(-182.037 -0.127)"
            fill="#bbbfc4"
          />
        </g>
      </g>
      <g transform="translate(573.66 65.473)">
        <g transform="translate(7.982 0.127)">
          <path
            d="M188.011.127H182.47a.433.433,0,0,0-.433.433V6.1a.433.433,0,0,0,.433.433h5.541a.433.433,0,0,0,.433-.433V.56A.433.433,0,0,0,188.011.127Z"
            transform="translate(-182.037 -0.127)"
            fill="#bbbfc4"
          />
        </g>
        <path
          d="M1.532,3.452a.2.2,0,0,1-.289,0L.09,2.3a.306.306,0,0,1,0-.433l.144-.144a.306.306,0,0,1,.433,0l.72.72L3.333.5a.306.306,0,0,1,.433,0L3.91.64a.306.306,0,0,1,0,.433Zm0,0"
          transform="translate(9.225 1.5)"
          fill="#fff"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconRubric)
